import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#005ce6",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m14.9213 16.7583-10.67496-8.3-.85938-.66875.8625.67188v16.28747h23.50004v-16.28747l-10.6813 8.29687c-.307.2385-.6847.368-1.0734.368-.3888 0-.7665-.1295-1.0735-.368z",
				opacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m27.3833 6.21143 1.2281 1.57811-.8625.67187.8657-.67187-1.2282-1.57811z",
				opacity: .1
			}),
			/* @__PURE__ */ _jsx("path", { d: "m29 5h-26c-.55313 0-1 .44687-1 1v20c0 .5531.44687 1 1 1h26c.5531 0 1-.4469 1-1v-20c0-.55313-.4469-1-1-1zm-2.9531 2.25313-10.0469 7.80937-10.04688-7.80937zm1.7031 1.20937v16.2875h-23.5v-16.2875l-.8625-.67187.85937.66875 10.67503 8.30002c.307.2385.6847.3679 1.0734.3679.3888 0 .7665-.1294 1.0735-.3679l10.6812-8.2969.8625-.67187-1.2281-1.57813h.0031l1.2281 1.57813z" })
		]
	})
});
export { SvgMail as ReactComponent };
